import BindAccount from './BindAccount.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'bindAccount', BindAccount);
  },
};
